import { Video, Play, Clock, ExternalLink } from "lucide-react";

export const VideoCard = ({ videos, userProfile, onItemClick }) => {
  if (!videos || videos.length === 0) {
    return (
      <section className="card-surface p-5" data-testid="video-card-empty">
        <h3 className="text-title-lg font-headline text-[#F8FAFC] mb-4">Video Intelligence</h3>
        <p className="text-[#94A3B8] text-sm">No videos available for your current filters.</p>
      </section>
    );
  }

  return (
    <section className="card-surface p-5" data-testid="video-card">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <Video className="w-5 h-5 text-[#14B8A6]" />
          <h3 className="text-title-lg font-headline text-[#F8FAFC]">Video Intelligence</h3>
        </div>
      </div>

      <div className={`grid gap-4 ${
        videos.length === 1 ? "grid-cols-1"
        : videos.length === 2 ? "grid-cols-1 sm:grid-cols-2"
        : videos.length === 3 ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
        : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
      }`}>
        {videos.slice(0, 8).map((video, idx) => (
          <div
            key={video.id || idx}
            onClick={() => onItemClick && onItemClick(video)}
            className="group rounded-xl bg-white/[0.02] hover:bg-white/[0.05] border border-white/[0.04] hover:border-white/[0.08] transition-all duration-200 cursor-pointer overflow-hidden"
            data-testid={`video-item-${idx}`}
          >
            {/* Thumbnail */}
            <div className="relative aspect-video bg-[#112240] overflow-hidden">
              <img
                src={video.thumbnail_url || `https://images.pexels.com/photos/1181433/pexels-photo-1181433.jpeg`}
                alt={video.title}
                className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-300"
                loading="lazy"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/10 transition-colors">
                <div className="w-10 h-10 rounded-full bg-[#14B8A6]/90 flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                  <Play className="w-5 h-5 text-[#050B14] ml-0.5" fill="currentColor" />
                </div>
              </div>
              {video.duration && (
                <span className="absolute bottom-1.5 right-1.5 flex items-center gap-1 text-[10px] text-white bg-black/60 px-1.5 py-0.5 rounded">
                  <Clock className="w-3 h-3" /> {video.duration}
                </span>
              )}
            </div>

            {/* Info */}
            <div className="p-3">
              <h4 className="text-sm font-medium text-[#F8FAFC] group-hover:text-[#14B8A6] transition-colors line-clamp-2 mb-1">
                {video.title}
              </h4>

              <div className="flex items-center gap-2 mb-2">
                {video.channel_name && (
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-white/[0.04] text-[#94A3B8] flex items-center gap-1">
                    <ExternalLink className="w-2.5 h-2.5" /> {video.channel_name}
                  </span>
                )}
              </div>

              <p className="text-xs text-[#94A3B8] line-clamp-2">
                {video.summary}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
